<app-summary-section [stepRoute]="route" heading="OTHER_2.TYPE.HEADING">
  <app-chip>
    {{ "OTHER_2.TYPE." + otherType | translate }}
  </app-chip>
</app-summary-section>
